import Axioscall from "./Axios";

//Login
export const loginApi = (userData) => {
  return Axioscall.post("/auth/login", userData);
};

//Role List
export const roleListApi = () => {
  return Axioscall.get("role/list");
};

//Add Role
export const createRoleApi = (roleData) => {
  return Axioscall.post("role/create", roleData);
};

//Edit Role
export const editRoleApi = (id, data) => {
  return Axioscall.put("role/update/" + id, data);
};

//Delete Role
export const deleteRoleApi = (id) => {
  return Axioscall.delete("role/delete/" + id);
};

//forgot password
export const forgotPasswordApi = (userData) => {
  return Axioscall.post("/auth/forgot-password", userData);
};

//reset password
export const resetPasswordApi = (token, id, password) => {
  const token1 = localStorage.getItem("x-access-token");
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: token1,
  };
  return Axioscall.post(
    `/auth/reset-password?token=${token}&id=${id}`,
    password,
    headers
  );
};

// Get Employee List
export const getEmployeeList = ({ page }) => {
  return Axioscall.get(`/employee/list/${page}`);
};

//Get Searched Employee
export const getSearchedEmployeeList = ({ page, searchText }) => {
  return Axioscall.get(`/employee/list/${page}?search=${searchText}`);
};

//Get EMployee List Excel
export const employeeListExcel = () => {
  return Axioscall.get(`/excel/file?search=employee`);
};

// Get employee detail
export const getEmployeeDetail = (id) => {
  return Axioscall.get(`/employee/view/${id}`);
};

//Employee Registration
export const createEmployee = (employeeData) => {
  const token = localStorage.getItem("x-access-token");
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: token,
  };
  return Axioscall.post("/employee/create", employeeData, headers);
};

//Employee Edit
export const editEmployee = (employeeData, employeeId) => {
  const token = localStorage.getItem("x-access-token");
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: token,
  };
  return Axioscall.put(`/employee/update/${employeeId}`, employeeData, headers);
};

//VISITORS
//Get Vistors List
export const getVisitorsList = ({ page, zone }) => {
  return Axioscall.get(`visitor/list/${page}?zone=${zone}`);
};

//Get Vistors Detail
export const getVisitorsDetails = (visitorId) => {
  return Axioscall.get(`visitor/view/${visitorId}`);
};

//Visitors Registration
export const createVisitor = (visitorData) => {
  const token = localStorage.getItem("x-access-token");
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: token,
  };
  return Axioscall.post("/visitor/create", visitorData, headers);
};

//Visitors Edit
export const editVisitor = (visitorData, visitorId) => {
  const token = localStorage.getItem("x-access-token");
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: token,
  };
  return Axioscall.put(`/visitor/update/${visitorId}`, visitorData, headers);
};

//Get Vistors attendence List
export const getVisitorAttendance = (visitorId, page = 1) => {
  return Axioscall.get(`visitor/attendance/${visitorId}/${page}`);
};

//FEATURES
//Get Feature List
export const getFeatureList = () => {
  return Axioscall.get(`feature/list`);
};

//ROLES
//Get Role List
export const getRoleList = () => {
  return Axioscall.get(`role/list`);
};

export const createRole = (roleData) => {
  return Axioscall.post("/role/create", roleData);
};

//CATEGORY
//Get Category List
export const getCategoryList = () => {
  return Axioscall.get(`category/list`);
};
export const getVisitorTypeList = () => {
  return Axioscall.get(`category/visitorType/list`);
};

//home API
export const getHomeApi = () => {
  return Axioscall.get("/home");
};

//add device setting
export const getDeviceListApi = () => {
  return Axioscall.get("/settings/device/list");
};

//create device setting
export const createDeviceApi = (data) => {
  return Axioscall.post("/settings/create/device", data);
};

//update device setting
export const editDeviceApi = (data, id) => {
  return Axioscall.put(`/settings/device/update/${id}`, data);
};

//Get permissions list
export const getPermissionsList = () => {
  return Axioscall.get(`/role/list/permissions`);
};

//Get permissions list
export const updatePermissionsList = (data, id) => {
  return Axioscall.put(`/role/permissions/update`, data);
};

//report lisiting
export const reportListData = ({
  page,
  filter,
  fromDate,
  toDate,
  category,
}) => {
  if (filter === "zone" || category === "All") {
    return Axioscall.get(
      `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}`
    );
  } else {
    return Axioscall.get(
      `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}&visitorType=${category}`
    );
  }
};

//report listing FILTER
export const reportListDataFilter = ({
  page,
  filter,
  fromDate,
  toDate,
  categoryFilter,
  zone,
}) => {
  if (zone != false && categoryFilter != false) {
    return Axioscall.get(
      `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}&zoneFilter=${zone}&categoryFilter=${categoryFilter}`
    );
  } else if (zone != false && categoryFilter === false) {
    return Axioscall.get(
      `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}&zoneFilter=${zone}`
    );
  } else if (zone === false && categoryFilter != false) {
    return Axioscall.get(
      `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}&categoryFilter=${categoryFilter}`
    );
  } else if (zone === false && categoryFilter === false) {
    return Axioscall.get(
      `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}`
    );
  }
};

//Status Api
export const getstatus = (filter, emp) => {
  return Axioscall.get(`/status/list?filter=${filter}&empData=${emp}`);
};

//Ert List Api
export const getErtList = (filter, emp) => {
  return Axioscall.get(`/ert/filter-list`);
};

//Ert detal Api
export const getErtDetail = (id) => {
  return Axioscall.get(`ert/list/${id}`);
};

//Get Category ertList
export const getERTList = () => {
  return Axioscall.get(`ert/ertlist`);
};

//Get Reassign Role List
export const getReAssignRole = (role) => {
  return Axioscall.get(`settings/admin/list?role=${role}`);
};

//profile page api
export const getProfilePage = () => {
  return Axioscall.get(`profile/view`);
};

//add assign role
export const createAssignRole = (roleData) => {
  return Axioscall.post(`settings/admin/create`, roleData);
};

//edit assign role
export const editAssignApi = (roleData, id) => {
  return Axioscall.put(`settings/admin/update/${id}`, roleData);
};

//delete assign role
export const deleteAssignRoleApi = (id) => {
  return Axioscall.delete(`settings/admin/delete/` + id);
};

//emp list for select assign role
export const empListRoleApi = (empCode) => {
  return Axioscall.get(`role/list/employees?empCode=`, +empCode);
};

//Status Zone Page API
export const getStatusZone = ({ zone, activeZone, currentPage }) => {
  return Axioscall.get(
    `/status/list?filter=${zone}&empData=${activeZone}&page=${currentPage}`
  );
};

//Status emp Page API
export const getStatusEmp = ({ page, filter, empdata }) => {
  return Axioscall.get(
    `/status/list?filter=${filter}&empData=${empdata}&page=${page}`
  );
};

//Download Excel
export const downloadExcel = (fileName) => {
  return Axioscall.get(`/excel/${fileName}`);
};
// change password in profile
export const changePassword = (oldPassword, confirmPassword) => {
  return Axioscall.put(`profile/change-password`, {
    password: oldPassword,
    newPassword: confirmPassword,
  });
};

//ERT Page List
export const getERTPageList = () => {
  return Axioscall.get(`/ert/filter-list`);
};

//ERT Page List - Members List
export const getERTPageDetails = (id, status, categoryId) => {
  return Axioscall.get(
    `/ert/list/${id}?status=${status ? status : ""}&category=${
      categoryId ? categoryId : ""
    }`
  );
};

//ERT Category List
export const getERTCategoryList = () => {
  return Axioscall.get(`/ert/ertlist`);
};

//Employee master add group
export const createEmpGroup = (getExcelData) => {
  return Axioscall.post(`employee/create/group`, getExcelData);
};
//Contacts list call data API
export const getContactsList = () => {
  return Axioscall.get(`/contact/list`);
};

//Contacts submit Excel API
export const submitContactsListExcel = (contactsListExcel) => {
  return Axioscall.post(`/contact/create`, contactsListExcel);
};

//Status All
export const statusAllDetails = (category, pageNum) => {
  return Axioscall.get(
    `/status/list?filter=all&categoryFilter=${category}&page=${pageNum}`
  );
};
//safe assemble point api
export const getSafeAsseblePoint = ({ status, page, zone }) => {
  return Axioscall.get(
    `safe-assemble-point/list?status=${status}&page=${page}&zone=${zone}`
  );
};

//refresh token for remember me
export const createAccessToken = (refreshToken) => {
  return Axioscall.post(`auth/refreshToken`, refreshToken);
};
//download excel api's
export const getDownloadExcel = ({
  search,
  filter,
  empData,
  fromDate,
  toDate,
  zoneFilter,
  categoryFilter,
  visitorType,
}) => {
  return Axioscall.get(
    `excel/file?search=${search}&filter=${filter}&empData=${empData}&fromDate=${fromDate}&toDate=${toDate}&zoneFilter=${zoneFilter}&categoryFilter=${categoryFilter}&visitorType=${
      visitorType === "All" ? "" : visitorType
    }`
    // `excel/file?search=${search}&filter=${filter}&empData=${empData}&fromDate=${fromDate}&toDate=${toDate}&zoneFilter=${zoneFilter}&categoryFilter=${categoryFilter}`
  );
};

// Extended stay report
export const getExtendedStayData = ({ page, time }) => {
  return Axioscall.get(
    `/report/list/${page}?filter=extendStay&extendStayHours=${time}`
  );
};

// All report
export const getAllReportedData = ({ page, filter, fromDate, toDate }) => {
  return Axioscall.get(
    `/report/list/${page}?filter=${filter}&fromDate=${fromDate}&toDate=${toDate}`
  );
};

// Download extended stay report
export const downloadExtendedStayExcel = ({ search, filter, time }) => {
  return Axioscall.get(
    `/excel/file?search=${search}&filter=${filter}&extendStayHours=${time}`
  );
};
//magnetic card file upload
export const visitorMagneticCardApi = (visitorCard) => {
  return Axioscall.post(`visitor-card/create`, visitorCard);
};

//magnetic id list
export const magneticListApi = (search) => {
  return Axioscall.get(`visitor-card/list?search=`, +search);
};

//Get visitor card Excel
export const visitorCardExcel = () => {
  return Axioscall.get(`/excel/file?search=magneticCard`);
};

// delete employee
export const deleteEmployeeData = (id) => {
  return Axioscall.delete(`/employee/delete/${id}`);
};
// exented stay add api
export const addExtentedStay = (extendedvalue) => {
  return Axioscall.post(`settings/extendedStay/create`, extendedvalue);
};
// manul punchout of extentd saty report
export const manulPunchOutUsers = (userDetails) => {
  return Axioscall.post(`report/punch-out-user`, userDetails);
};
// getgetextentedValue saved
export const getextentedValue = () => {
  return Axioscall.get(`settings/extendedStay`);
};

// download excel for report - all case
export const downloadExcelReportAll = ({
  search,
  filter,
  empData,
  fromDate,
  toDate,
  zoneFilter,
  categoryFilter,
  visitorType,
}) => {
  // {search,filter,fromDate,toDate}

  return Axioscall.get(
    // `/excel/file?search=report&filter=all&fromDate=2024-07-12&toDate=2024-07-18`
    `/excel/file?search=${search}&filter=${filter}&fromDate=${fromDate}&toDate=${toDate}`
    // `excel/file?search=${search}&filter=${filter}&empData=${empData}&fromDate=${fromDate}&toDate=${toDate}&zoneFilter=${zoneFilter}&categoryFilter=${categoryFilter}&visitorType=${visitorType}`
  );
};
